import { useHotKey } from './use-hot-key';

const navTreeSelector = '.form-tree__container :not([aria-hidden="true"]) > ol > li:not([style*="display: none"]) > .form-tree__node-parent:not([inert])';
const listFocused = (nodeSelector) => {
	return !!document.activeElement.closest(nodeSelector);
};

const getActiveIndex = (nodeList, nodeSelector) => {
	let i = 0;
	for (const n of nodeList) {
		if (n === document.activeElement.closest(nodeSelector))
			return i;
		i++;
	}
};

export const handleItemRemoval = (nodeSelector = navTreeSelector) => {
	const nodeList = document.querySelectorAll(nodeSelector);

	if (nodeList.length > 1)
		nodeList[Math.min(getActiveIndex(nodeList, nodeSelector) + 1, nodeList.length - 2)].focus();
};

export const focusFirstItem = (e = undefined, nodeSelector = navTreeSelector) => {
	if (e)
		e.stopPropagation();
	if (document.querySelector(nodeSelector))
		document.querySelector(nodeSelector).focus();
};

export const setupKeyboardNavigation = (nodeSelector = navTreeSelector) => {
	useHotKey('ArrowDown', () => listFocused(nodeSelector), () => {
		const nodeList = document.querySelectorAll(nodeSelector);
		nodeList[Math.min(nodeList.length - 1, getActiveIndex(nodeList, nodeSelector) + 1)].focus();
	});

	useHotKey('ArrowUp', () => listFocused(nodeSelector), () => {
		const nodeList = document.querySelectorAll(nodeSelector);
		nodeList[Math.max(0, getActiveIndex(nodeList, nodeSelector) - 1)].focus();
	});

	useHotKey('Home', () => listFocused(nodeSelector), () => {
		focusFirstItem(undefined, nodeSelector);
	});

	useHotKey('End', () => listFocused(nodeSelector), () => {
		const nodeList = document.querySelectorAll(nodeSelector);
		nodeList[nodeList.length - 1].focus();
	});
};